import * as yup from 'yup'

export const feedbackClassNoPresenceSchema = yup.object().shape({
	rating: yup.number().optional(),
	feedback: yup.string().optional(),
	tag: yup.array().of(yup.string().required()).optional(), // Garante que cada elemento é uma string
})

export const feedbackClassSchema = yup.object().shape({
	rating: yup.number().required(),
	feedback: yup.string(),
	tag: yup.array().of(yup.string().required()), // Garante que o array é de strings
	atLeastOne: yup.mixed().when('rating', {
		is: (rating: number): boolean => rating <= 3,
		then: (schema) =>
			schema.test({
				name: 'at-least-one',
				message: 'Preencha um dos campos obrigatórios (feedback ou tag).',
				test: function () {
					const { feedback, tag } = this.parent
					return feedback || (tag && tag.length > 0)
				},
			}),
		otherwise: (schema) => schema.optional(),
	}),
})
